import { render, staticRenderFns } from "./AddMaterial.vue?vue&type=template&id=25d3beda&"
import script from "./AddMaterial.vue?vue&type=script&lang=js&"
export * from "./AddMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports